import script from "./SubjectiveQuiz.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectiveQuiz.vue?vue&type=script&setup=true&lang=js"

import "./SubjectiveQuiz.vue?vue&type=style&index=0&id=481b92c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-481b92c4"]])

export default __exports__